import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import { Card } from "../kit/Kit";
import { mxn, sel } from "./common";

export const CapEscenario = ({ qa }) => {
  const [pct, setPct] = useState("");
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/captacion/alm/escenario", { params: { qa, ...(pct !== "" ? { rollover_pct: Number(pct) } : {}) } }).then((r) => setD(r.data)); }, [qa, pct]);
  if (!d?.corte) return null;
  return (
    <Card title="Escenario ALM por instrucción al vencimiento" testid="cap-escenario"
      right={<label className="flex items-center gap-2 text-xs">Rollover %<input type="number" value={pct} placeholder={String(d.rollover_pct)} onChange={(e) => setPct(e.target.value)} className={`${sel} w-20`} data-testid="cap-escenario-rollover" /></label>}>
      <p className="mb-2 text-xs text-[#5C5850]">{d.nota}</p>
      <div className="overflow-x-auto"><table className="w-full min-w-[460px] text-xs" data-testid="cap-escenario-tabla">
        <thead><tr className="text-left text-[#8C867A]"><th className="py-1">Banda</th><th>Base contractual</th><th>Escenario instrucción</th><th>Liquidar</th><th>Reinvertir</th><th>Sin dato</th></tr></thead>
        <tbody>{d.buckets.map((b) => <tr key={b.bucket} className="border-t border-[#F2F0EC]"><td className="py-1 font-medium">{b.bucket}</td><td>{mxn(b.contractual)}</td><td><b>{mxn(b.por_instruccion)}</b></td><td>{mxn(b.liquidar)}</td><td>{mxn(b.reinvertir)}</td><td>{mxn(b.sin_dato)}</td></tr>)}</tbody>
      </table></div>
    </Card>
  );
};
